/**
 * SaveButton Handler для форм ресурсів
 * 
 * Додає кнопку "Зберегти" що викликає submit на формі
 */

import React from 'react'
import { IoSaveOutline } from 'react-icons/io5'
import type { IFormButtonHandlerParams } from '../../types'

/**
 * Додає кнопку "Зберегти"
 * Відображається в режимі створення/редагування
 * 
 * @param params - параметри з buttons та crudContext
 */
export const SaveButton = ({ buttons, crudContext }: IFormButtonHandlerParams) => {
    buttons['save'] = {
        sort: 900,
        icon: React.createElement(IoSaveOutline, { style: { fontSize: 19 } }),
        depFn: () => {
            if (!crudContext || !crudContext.formContext) return false
            const isEditable = crudContext.formContext.isEditable
            const hasId = crudContext.formContext.values?.['@id']?.length > 0
            const canUpdate =
                hasId &&
                crudContext.accessFn &&
                typeof crudContext.accessFn === 'function' &&
                crudContext.accessFn({
                    accessMode: 'update',
                    accessItem: crudContext.formContext.values,
                    crudContext: crudContext,
                })
            const canCreate =
                !hasId &&
                crudContext.accessFn &&
                typeof crudContext.accessFn === 'function' &&
                crudContext.accessFn({
                    accessMode: 'create',
                    accessItem: crudContext.formContext.values,
                    crudContext: crudContext,
                })
            return isEditable && (canUpdate || canCreate)
        },
        loading: () => crudContext.formContext?.isLoading || false,
        type: 'primary',
        size: 'middle',
        onClick: () => {
            if (crudContext?.formComposerContext) crudContext.formComposerContext.submit()
            else if (crudContext?.formContext) crudContext.formContext.submit()
        },
        label: 'Зберегти',
    }
}
